export function userConstants(lang) {
  const esStrings = {
    submitButtonInUpperCase: 'ENVIAR',
    submitButtonInLowerCase: 'Enviar',
    nextButton: 'Siguiente >',
    of: 'de',
    successHeader: 'Éxito',
    submitResponseSuccess: 'Envío exitoso',
    okayBtn: 'OK',
    finalSuccessMessage: '¡Gracias por tus respuestas!',
    textAreaPlaceholder: 'Porfavor escriba su respuesta aqui.',
    enterParagraph: 'Ingrese el párrafo',
    noResponse: 'Sin respuesta registrada',
    question: 'Pregunta',
    tapHelperText: 'Elige una opción. Siempre puedes volver atrás.',
  };
  const enStrings = {
    submitButtonInUpperCase: 'SUBMIT',
    submitButtonInLowerCase: 'Submit',
    nextButton: 'Next >',
    of: 'of',
    successHeader: 'Success',
    submitResponseSuccess: 'Successfully submitted the response',
    okayBtn: 'OKAY',
    finalSuccessMessage: 'Thank you for submitting the response!',
    textAreaPlaceholder: 'Please write your answer here.',
    enterParagraph: 'Enter paragraph',
    noResponse: 'No Response Recorded',
    question: 'Question',
    tapHelperText: 'Select an option. You can always go back.',
  };
  const ptStrings = {
    submitButtonInUpperCase: 'ENVIAR',
    submitButtonInLowerCase: 'Enviar',
    nextButton: 'Próximo >',
    of: 'de',
    successHeader: 'Sucesso',
    submitResponseSuccess: 'Resposta enviada com sucesso',
    okayBtn: 'OK',
    finalSuccessMessage: 'Obrigado por enviar a resposta!',
    textAreaPlaceholder: 'Por favor, Escreva sua resposta aqui.',
    enterParagraph: 'Digite o parágrafo',
    noResponse: 'Nenhuma resposta registrada',
    question: 'Pergunta',
    tapHelperText: 'Escolha uma opção. Você sempre pode voltar.',
  };
  const hiStrings = {
    submitButtonInUpperCase: 'सबमिट करें',
    submitButtonInLowerCase: 'सबमिट करें',
    nextButton: 'अगला >',
    of: 'में से',
    successHeader: 'सफलता',
    submitResponseSuccess: 'प्रतिक्रिया सफलतापूर्वक सबमिट की गई',
    okayBtn: 'ठीक है',
    finalSuccessMessage: 'प्रतिक्रिया सबमिट करने के लिए धन्यवाद!',
    textAreaPlaceholder: 'कृपया यहाँ अपना उत्तर लिखें।',
    enterParagraph: 'अनुच्छेद दर्ज करें',
    noResponse: 'कोई प्रतिक्रिया दर्ज नहीं हुई',
    question: 'प्रश्न',
    tapHelperText: 'एक विकल्प चुनें। आप हमेशा पीछे जा सकते हैं।',
  };

  switch (lang) {
    case 'es': return esStrings;
    case 'pt': return ptStrings;
    case 'hi': return hiStrings;
    case 'en':
    default: return enStrings;
  }
}
